/* eslint-disable @typescript-eslint/indent */
import { AttributeId, SearchParams } from 'jobs.types';

interface Params {
  filter: { search: SearchParams; jobAbo: SearchParams };
  setFilter: (filter: { search: SearchParams; jobAbo: SearchParams }) => void;
}

const getOnChangeAboFilter =
  ({ setFilter, filter }: Params) =>
  (attributeId: AttributeId, elementId: string) => {
    if (elementId === 'showAll') {
      setFilter({
        ...filter,
        jobAbo: {
          ...filter.jobAbo,
          [attributeId]: [],
        },
      });
      return;
    }

    const newAboFilter = { ...filter.jobAbo };
    if (!(attributeId in newAboFilter)) {
      newAboFilter[attributeId] = [elementId];
    } else if (newAboFilter[attributeId].includes(elementId)) {
      newAboFilter[attributeId] = newAboFilter[attributeId].filter(
        (id) => id !== elementId,
      );
    } else {
      newAboFilter[attributeId].push(elementId);
    }

    if (newAboFilter[attributeId].length === 0) {
      delete newAboFilter[attributeId];
    }

    setFilter({ ...filter, jobAbo: newAboFilter });
  };

export default getOnChangeAboFilter;
